import React, {Component} from 'react';
import Styles from './style.css';
import cx from 'classnames';
import {langRegister} from "../../services/langRegister";
import {marketRegister} from "../../services/marketRegister";
import {salesChannelRegister} from "../../services/salesChannelRegister";

class BoosterHomePrice extends Component {

    constructor(props) {
        super(props);
        this.state = {
            items: [],
            lockin: false
        };
    };

    componentWillMount() {
        this._updateItems();
    }

    _updateItems() {
        let items = [
            {
                active: true,
                title: this._renderText("item_1"),
                subtitle: this._renderText("item_2"),
                price: 0,
                currency: salesChannelRegister.get("currency"),
                promo: this._renderText("item_24"),
                items: [
                    this._renderText("item_4"),
                    this._renderText("item_3"),
                    this._renderText("item_5"),
                    this._renderText("item_22"),
                    this._renderText("item_6"),
                    this._renderText("item_7"),
                    this._renderText("item_20"),
                    this._renderText("item_8")
                ],
                button: this._renderText("item_9"),
                button_link: "/" + salesChannelRegister.get('market') + "/" + langRegister.lang()+ "/register"
            },
            {
                active: false,
                title: this._renderText("item_10"),
                subtitle: this._renderText("item_11"),
                price: -1,
                new_price_color: "black",
                currency: salesChannelRegister.get("currency"),
                items: [
                    this._renderText("item_12"),
                    this._renderText("item_13"),
                    this._renderText("item_23"),
                    this._renderText("item_14"),
                    this._renderText("item_15"),
                    this._renderText("item_16"),
                    this._renderText("item_21"),
                    this._renderText("item_17")
                ],
                button: this._renderText("item_18"),
                button_link: "/" + salesChannelRegister.get('market') + "/" + langRegister.lang()+ "/reseller?scrolldown=signup"
            },
        ];
        this.setState({items: items});
    }

    _toggleLockin(){
        this.setState({lockin: !this.state.lockin});
    }

    _renderPrice(value){
        if(this.state.lockin){
            return this._renderNumbers((value * (marketRegister.lockin() - marketRegister.discount())));
        }else{
            return value;
        }
    }

    _renderNumbers(x) {
        try {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        } catch (e) {
            return ("...")
        }
    }

    _renderText(item) {
        return langRegister.get("booster-home-price", item);
    }

    render() {
        return (
            <div className={Styles.section}>
                <div className={Styles.container}>
                    <div className={Styles.items}>
                        {
                            this.state.items.map((item) => {
                                return(
                                    <div className={
                                        cx(Styles.item,
                                            {
                                                [Styles.itemGreen]: item.active,
                                            })
                                    }>
                                        <div className={Styles.itemTitle}>
                                            {
                                                false && //!this.state.lockin &&
                                                item.title
                                            }
                                            {
                                                false && //this.state.lockin &&
                                                <span>{item.multiple}</span>
                                            }
                                        </div>
                                        <div className={
                                            cx(Styles.itemSubtitle,
                                                {
                                                    [Styles.itemSubtitleNewPrice]: item.new_price,
                                                })
                                        }>
                                            {item.subtitle}
                                        </div>
                                        {
                                            item.new_price &&
                                            <div className={Styles.itemNewPriceTitle}>
                                                {this._renderText("item_16")}
                                            </div>
                                        }
                                        <div className={
                                            cx(Styles.itemPrice,
                                                {
                                                    [Styles.itemPriceGreen]: item.active,
                                                    [Styles.itemPriceNewPrice]: item.new_price,
                                                })
                                        }>
                                            <div className={Styles.centerText}>
                                                {
                                                    false && //item.price > -1 &&
                                                    <div className={
                                                        cx(Styles.itemPriceCurrency,
                                                            {
                                                                [Styles.itemPriceGreen]: item.active,
                                                            })
                                                    }>{item.currency}
                                                    </div>
                                                }
                                                {
                                                    item.price > -1 &&
                                                    this._renderText("item_26") //this._renderPrice(item.price)
                                                }
                                                {
                                                    item.price === -1 &&
                                                    <span className={Styles}>{this._renderText("item_19")}</span>
                                                }
                                            </div>
                                            <div>
                                                {
                                                    item.active &&
                                                    <div className={Styles.itemPromoBox}>
                                                        <span className={Styles.itemPromoBread}>{item.promo + " "}</span>{this._renderText("item_25")}
                                                    </div>
                                                }
                                            </div>
                                            {
                                                item.new_price &&
                                                <div className={
                                                    cx(Styles.itemPriceRemove,
                                                        {
                                                            [Styles.itemPriceRemoveBlack]: item.new_price_color === "black",
                                                        })
                                                }/>
                                            }
                                            {
                                                item.new_price &&
                                                <div>
                                                    <div className={Styles.itemPriceContainer}>
                                                        <div className={
                                                            cx(Styles.itemPriceCurrency,
                                                                {
                                                                    [Styles.itemPriceRed]: true,
                                                                })
                                                        }>{item.currency}</div>
                                                        <div className={Styles.itemPriceNew}>
                                                            {this._renderPrice(item.new_price)}
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                        {
                                            item.items.map((item, key) => {
                                                return(
                                                    <div className={cx(Styles.itemValue)}>
                                                        {item}
                                                    </div>
                                                )
                                            })
                                        }
                                        <div className={Styles.itemValueLast}/>
                                        <div onClick={() => this.props.props.history.push(item.button_link)}  className={
                                            cx(Styles.itemButton,
                                                {
                                                    [Styles.itemButtonGreen]: item.active,
                                                })
                                        } >
                                            {item.button}
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default BoosterHomePrice;


// WEBPACK FOOTER //
// ./src/components/booster-home-price/component.js